/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFDecisionRecord } from './CRSFDecisionRecord';
import {
    CRSFDecisionRecordFromJSON,
    CRSFDecisionRecordFromJSONTyped,
    CRSFDecisionRecordToJSON,
} from './CRSFDecisionRecord';

/**
 * 
 * @export
 * @interface CRSFDecisionsPagedResponse
 */
export interface CRSFDecisionsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFDecisionsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFDecisionsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFDecisionRecord>}
     * @memberof CRSFDecisionsPagedResponse
     */
    results?: Array<CRSFDecisionRecord>;
    /**
     * 
     * @type {number}
     * @memberof CRSFDecisionsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFDecisionsPagedResponse interface.
 */
export function instanceOfCRSFDecisionsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFDecisionsPagedResponseFromJSON(json: any): CRSFDecisionsPagedResponse {
    return CRSFDecisionsPagedResponseFromJSONTyped(json, false);
}

export function CRSFDecisionsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDecisionsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFDecisionRecordFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFDecisionsPagedResponseToJSON(value?: CRSFDecisionsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFDecisionRecordToJSON)),
        'total': value.total,
    };
}

